
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.708 16.286H8.279a.857.857 0 000 1.714h7.429a.857.857 0 000-1.714z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.992 6c.473 0 .857.386.857.857v4.792l1.108-1.115a.858.858 0 111.212 1.217l-2.571 2.572a.858.858 0 01-1.212 0L8.815 11.75a.858.858 0 111.212-1.217l1.108 1.115V6.857c0-.471.384-.857.857-.857z"}})])
          )
        }
      }
    